import { useEffectiveRole } from "@/hooks/use-effective-role";
import { DmMqttTable } from "./dm-mqtt-table";
import { ResellerMqttTable } from "./reseller-mqtt-table";
import { RmMqttTable } from "./rm-mqtt-table";

export function MqttSourcesTable() {
	const role = useEffectiveRole();

	if (role === "reseller_manager") return <RmMqttTable />;
	if (role === "reseller") return <ResellerMqttTable />;
	if (role === "district_manager") return <DmMqttTable />;
	return null;
}
